export default __webpack_public_path__ + "static/media/regreen_visual_06.f573b6ad.jpg";